import { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { put } from 'helpers/apiHelpers';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useTranslation } from 'react-i18next';
import ChangePasswordForm from 'components/ChangePasswordForm/ChangePasswordForm';
import { toast } from 'react-toastify';
import {
  hasRequiredPasswordRules,
  isPasswordMatch,
} from 'helpers/passwordValidator';

import S from './AuthStyled';

const ResetPassword = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { token } = useParams();

  const [state, setState] = useState({
    plainPassword: '',
    plainPasswordMatch: '',
    focusedPasswordRepeat: false,
    focusedPassword: false,
    isLoading: false,
    errorMessage: null,
  });

  const { plainPassword, plainPasswordMatch, isLoading } = state;

  const isFormValid = () =>
    hasRequiredPasswordRules(plainPassword) &&
    isPasswordMatch(plainPassword, plainPasswordMatch);

  const validateForm = () => {
    if (plainPassword) {
      const meetsRequiredPasswordRules = isFormValid();

      if (!meetsRequiredPasswordRules) {
        toast.error(t('resetPassword.errors.passwordRequirements'));

        return false;
      }
    }

    if (!isPasswordMatch(plainPassword, plainPasswordMatch)) {
      toast.error(t('resetPassword.passwordsDontMatch'));

      return false;
    }

    return true;
  };

  const handleSubmit = async ev => {
    ev.preventDefault();

    if (!validateForm()) {
      return;
    }

    setState(prevState => ({
      ...prevState,
      isLoading: true,
    }));

    try {
      await put('/change-password', {
        plainPassword,
        token,
      });

      setState(prevState => ({
        ...prevState,
        isLoading: false,
        plainPassword: '',
      }));
    } catch (error) {
      if (error.response && error.response.status === 400) {
        setState(prevState => ({
          ...prevState,
          isLoading: false,
          errorMessage: error.response.data.violations[0].message,
        }));
      }
    }

    history.push('/auth/login');
  };

  return (
    <>
      <S.AuthHeader>{t('common.passwordResetForm.header')}</S.AuthHeader>
      <S.AuthParagraph icon={true}>
        {t('common.passwordResetForm.infoMessage')}
      </S.AuthParagraph>

      <S.AuthForm changePassword={true} onSubmit={handleSubmit}>
        <ChangePasswordForm
          state={state}
          setState={setState}
          passwordInputVariant="framedInput"
        />

        {isLoading ? (
          <CircularProgress />
        ) : (
          <S.AuthButton type="submit" disabled={!isFormValid()}>
            {t('common.passwordResetForm.changePassword')}
          </S.AuthButton>
        )}

        <S.AuthLink onClick={() => history.push('/auth/login')}>
          {t('common.passwordResetForm.cancel')}
        </S.AuthLink>
      </S.AuthForm>
    </>
  );
};

export default ResetPassword;
